import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Hides the Charla chat widget on signed-in dashboard routes
 * (/admin/* and /my-account/*) so it doesn't cover dashboard UI.
 *
 * The widget itself is injected by the snippet in public/index.html on
 * window-load. We just toggle its CSS visibility based on the current path.
 */
const HIDDEN_PREFIXES = ["/admin", "/my-account"];

export default function ChatWidgetGate() {
  const { pathname } = useLocation();

  useEffect(() => {
    const shouldHide = HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));

    const apply = () => {
      const w = document.querySelector("charla-widget");
      if (!w) return false;
      w.style.display = shouldHide ? "none" : "";
      return true;
    };

    // Widget loads after window.load — element may not exist yet on first render.
    if (apply()) return;
    const interval = setInterval(() => { if (apply()) clearInterval(interval); }, 250);
    const timeout = setTimeout(() => clearInterval(interval), 8000);
    return () => { clearInterval(interval); clearTimeout(timeout); };
  }, [pathname]);

  return null;
}
